import { render } from "./Inbox.vue?vue&type=template&id=77620435&scoped=true&ts=true"
import script from "./Inbox.vue?vue&type=script&lang=ts"
export * from "./Inbox.vue?vue&type=script&lang=ts"

import "./Inbox.vue?vue&type=style&index=0&id=77620435&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77620435"]])

export default __exports__